import Vue from 'vue';
import BzbsApi from '@/service/BzbsApi.js';
import CampaignModel from '@/model/CampaignModel.js';

/**
 * @method apiGetCampaign
 * @method apiGetCampaignDetail
 * @method apiRedeemCampaign
 */
export default {
    /**
     *
     * @param {String} strBzbsToken
     * @param {Object} objListConfig CampaignListConfigModel - /service/config/CampaignConfigModel.js
     * @param {Object} objListFilterConfig CampaignListFilterConfigModel - /service/config/CampaignConfigModel.js
     */
    apiGetCampaign: function (strBzbsToken, objListConfig, objListFilterConfig) {
        var params = {};

        if (objListConfig.strConfigList) {
            params.byConfig = "true";
            params.config = objListConfig.strConfigList;
        }
        if (objListConfig.defaultTopAmount != 25) {
            params.top = objListConfig.defaultTopAmount;
        }

        if (objListConfig.intSkip) {
            params.skip = objListConfig.intSkip;
        }

        if (objListConfig.strTags) {
            params.tags = objListConfig.strTags;
        }

        if (objListConfig.strCatId) {
            params.cat = objListConfig.strCatId;
        }

        if (objListConfig.strLocale) {
            params.device_locale = objListConfig.strLocale;
        }

        if (objListConfig.strType) {
            params.type = objListConfig.strType;
        }

        if (objListConfig.strMode) {
            params.mode = objListConfig.strMode;
        }

        if (objListFilterConfig) {

            if (objListFilterConfig.strSearch) {
                params.q = objListFilterConfig.strSearch;
            }

            if (objListFilterConfig.strStartDate) {
                params.startdate = objListFilterConfig.strStartDate;
            }

            if (objListFilterConfig.strNearby) {
                params.center = objListFilterConfig.strNearby;
            }

            if (objListFilterConfig.strLocation) {
                params.location = objListFilterConfig.strLocation;
            }

            if (objListFilterConfig.strLocationAgencyId) {
                params.locationAgencyId = objListFilterConfig.strLocationAgencyId;
            }

            if (objListFilterConfig.intMinPoint) {
                params.minpoints = objListFilterConfig.intMinPoint;
            }

            if (objListFilterConfig.intMaxPoint) {
                params.maxpoints = objListFilterConfig.intMaxPoint;
            }

            if (objListFilterConfig.intMinPrice) {
                params.minprice = objListFilterConfig.intMinPrice;
            }

            if (objListFilterConfig.intMaxPrice) {
                params.maxprice = objListFilterConfig.intMaxPrice;
            }

            if (objListFilterConfig.intMinRating) {
                params.minrating = objListFilterConfig.objListFilterConfigintMinRating;
            }

            if (objListFilterConfig.intMaxRating) {
                params.maxrating = objListFilterConfig.intMaxRating;
            }
        }

        // var strUrl = Vue.bzbsConfig.bzbsUrl+ "/api/campaign";
        // var strUrl = Vue.bzbsConfig.bzbsUrl+ "/modules/chanel/campaign";
        var strUrl = Vue.bzbsConfig.newBzbsModuleUrl+ "/campaign";
        return new Promise((resolve, reject) => {
            BzbsApi.connectBzbsGet(strUrl, strBzbsToken, params).then((response) => {
                var arrCampaign = [];
                for (var i of response.data) {
                    var objCampaign = new CampaignModel(i);
                    arrCampaign.push(objCampaign);
                }

                resolve(arrCampaign);
            }).catch((error) => {
                reject(error);
            });
        });
    },

    /**
     * @param {String} strBzbsToken
     * @param {Object} objDetailConfig CampaignConfigModel - /service/config/CampaignConfigModel.js
     */
    apiGetCampaignDetail: function (strBzbsToken, objDetailConfig) {
        var params = {};

        if (objDetailConfig.strType) {
            params.type = objDetailConfig.strType;
        }

        if (objDetailConfig.strLocale) {
            params.device_locale = objDetailConfig.strLocale;
        }

        if (objDetailConfig.isWithRelate) {
            params.with_relate = objDetailConfig.isWithRelate;
        }

        if (objDetailConfig.strRelateConfig) {
            params.relate_config = objDetailConfig.strRelateConfig;
        }

        if (objDetailConfig.intRelateTop) {
            params.relate_top = objDetailConfig.intRelateTop;
        }

        if (objDetailConfig.strSponsorId) {
            params.sponsorId = objDetailConfig.strSponsorId;
        }

        if (objDetailConfig.strRedeemMedia) {
            params.redeem_media = objDetailConfig.strRedeemMedia;
        }

        if (objDetailConfig.strWalletCard) {
            params.walletcard = objDetailConfig.strWalletCard;
        }

        params.campaignid = objDetailConfig.strId;
        //var url = Vue.bzbsConfig.bzbsUrl + "/api/campaign/" + objDetailConfig.strId;
        // var url = Vue.bzbsConfig.bzbsUrl + "/modules/chanel/campaign/detail";
        var url = Vue.bzbsConfig.newBzbsModuleUrl + "/campaign/detail";
        return new Promise((resolve, reject) => {
            BzbsApi.connectBzbsGet(url, strBzbsToken, params).then((data) => {
                var campaign = new CampaignModel(data.data);
                resolve(campaign);
            }).catch((error) => {
                reject(error);
            });
        });

    },

    /**
     *
     * @param {String} strBzbsToken
     * @param {String|Number} campaignId
     * @param {Object} objRedeemConfig RedeemConfigModel - /service/config/CampaignModel.js
     * @param {Object} objRedeemProfileInfoConfig RedeemShippingAdressModel - /service/config/CampaignModel.js
     * @param {Object} objRedeemInfoConfig RedeemInfoConfigModel - /service/config/CampaignModel.js
     * @param {Object} objRedeemLocationConfig RedeemLocationConfigModel - /service/config/CampaignModel.js
     * @param {Object} objRedeemOtherConfig RedeemOtherConfigModel - /service/config/CampaignModel.js
     */
    apiRedeemCampaign: function (strBzbsToken, campaignId, objRedeemConfig, objRedeemProfileInfoConfig, objRedeemInfoConfig, objRedeemLocationConfig, objRedeemOtherConfig) {
        var params = {};

        if (!campaignId) {
            // failCallback("-9400", "-9400", "Bad parameter::Missing campaign model configuration.", "template_send", objRedeemConfig);
            return null;
        }

        if (!objRedeemConfig) {
            // failCallback("-9400", "-9400", "Bad parameter::Missing redeem configuration.", "template_send", objRedeemConfig);
            return null;
        } else {
            if (objRedeemConfig.redeemMedia) params.redeem_media = objRedeemConfig.redeemMedia;
            if (objRedeemConfig.walletCard) params.walletcard = objRedeemConfig.walletCard;
        }

        if (objRedeemProfileInfoConfig) {
            if (objRedeemProfileInfoConfig.firstName)
                params.firstname = objRedeemProfileInfoConfig.firstName;

            if (objRedeemProfileInfoConfig.lastName)
                params.lastname = objRedeemProfileInfoConfig.lastName;

            if (objRedeemProfileInfoConfig.address)
                params.address = objRedeemProfileInfoConfig.address;

            if (objRedeemProfileInfoConfig.contactNumber)
                params.contact_number = objRedeemProfileInfoConfig.contactNumber;

            if (objRedeemProfileInfoConfig.email)
                params.email = objRedeemProfileInfoConfig.email;

            if (objRedeemProfileInfoConfig.shippingFirstName)
                params.shippingFirstName = objRedeemProfileInfoConfig.shippingFirstName;

            if (objRedeemProfileInfoConfig.shippingLastName)
                params.shippingLastName = objRedeemProfileInfoConfig.shippingLastName;

            if (objRedeemProfileInfoConfig.zipcode)
                params.zipcode = objRedeemProfileInfoConfig.zipcode;

            if (objRedeemProfileInfoConfig.addressKey)
                params.address_key = objRedeemProfileInfoConfig.addressKey;
        }

        if (objRedeemInfoConfig) {
            if (objRedeemInfoConfig.info1) params.info1 = objRedeemInfoConfig.info1;
            if (objRedeemInfoConfig.info2) params.info2 = objRedeemInfoConfig.info2;
            if (objRedeemInfoConfig.info3) params.info3 = objRedeemInfoConfig.info3;
            if (objRedeemInfoConfig.info4) params.info4 = objRedeemInfoConfig.info4;
            if (objRedeemInfoConfig.info5) params.info5 = objRedeemInfoConfig.info5;
        }

        if (objRedeemLocationConfig) {
            if (objRedeemLocationConfig.locationId) params.location_id = objRedeemLocationConfig.locationId;
            if (objRedeemLocationConfig.center) params.center = objRedeemLocationConfig.center;
            if (objRedeemLocationConfig.latitude) params.latitude = objRedeemLocationConfig.latitude;
            if (objRedeemLocationConfig.longitude) params.longitude = objRedeemLocationConfig.longitude;
        }

        if (objRedeemOtherConfig) {
            if (objRedeemOtherConfig.isCache == false) params.cache = objRedeemOtherConfig.isCache;
            if (objRedeemOtherConfig.redeemBy) params.redeem_by = objRedeemOtherConfig.redeemBy;
            if (objRedeemOtherConfig.tranId) params.tranId = objRedeemOtherConfig.tranId;
            if (objRedeemOtherConfig.reservationjson) params.reservationjson = objRedeemOtherConfig.reservationjson;
            if (objRedeemOtherConfig.promoCode) params.promocode = objRedeemOtherConfig.promoCode;
            if (objRedeemOtherConfig.spBaht) params.sp_baht = objRedeemOtherConfig.spBaht;
            if (objRedeemOtherConfig.spPoints) params.sp_points = objRedeemOtherConfig.spPoints;
            if (objRedeemOtherConfig.giftTo) params.giftto = objRedeemOtherConfig.giftTo;
        }

        // var strUrl = Vue.bzbsConfig.bzbsUrl + "/api/campaign/" + campaignId + "/redeem";
        var strUrl = Vue.bzbsConfig.newBzbsUrl + "/campaign/" + campaignId + "/redeem";
        return new Promise((resolve, reject) => {
            BzbsApi.connectBzbsPost(strUrl, strBzbsToken, params).then((res) => {
                var data = res.data;

                resolve(data)
            }).catch((error) => {
                reject(error);
            });
        });


    }

}
